var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider, Typography } from '@mui/material';
import DrawerComponent from '@src/components/Atoms/Drawer/Drawer';
import { Fragment, useEffect, useState } from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import InputFormik from '@src/components/Atoms/Formik/Input/InputFormik';
import TextAreaFormik from '@src/components/Atoms/Formik/TextArea/TextAreaFormik';
import { useAddresses, useBankAccounts, } from '@src/app/pages/TalentPage/TalentHooks/TalentDetail.hooks';
import { useJobTypes } from '@src/app/pages/JobTypePage/JobType/JobType.hooks';
import JobDetailForm from './JobDetailForm';
import { useCities } from '@src/app/pages/LookupPage/LookupHooks/Lookup.hooks';
import { useBanks } from '@src/app/pages/BankPage/BankHooks/Bank.hooks';
import { useNavigate } from 'react-router-dom';
import { useJob } from '@src/app/pages/JobPage/JobHooks/Job.hooks';
import { defaultOptionAddress, defaultOptionBank, jobInitialValues } from './Job.constant';
import MultiSelectFormik from '@src/components/Atoms/Formik/MultiSelect/MultiSelectFormik';
import { JobTypeEnum, userInformation } from '@src/app/helper';
import { handleFocus } from '@src/app/helper/NumberHelpers';
import { useSaldoTeams } from '@src/app/pages/SaldoTeamPage/SaldoTeamHooks/SaldoTeam.hooks';
var JobProcessFormSchema = Yup.object().shape({
    talentAddressPubId: Yup.string(),
    talentBankAccountPubId: Yup.string(),
    details: Yup.array().of(Yup.object().shape({
        profilePubId: Yup.string().required('Field belum diisi'),
        jobTypePubId: Yup.string().required('Field belum diisi'),
        exclusiveStatus: Yup.string().required('Field belum diisi'),
        fee: Yup.string().required('Field belum diisi'),
        totalPosts: Yup.string().required('Field belum diisi'),
        totalFollowers: Yup.string().required('Field belum diisi'),
        timeFrame: Yup.string().required('Field belum diisi'),
        notes: Yup.string(),
        owningType: Yup.string().required('Field belum diisi'),
        boostingType: Yup.string().required('Field belum diisi'),
    })),
});
var ProcessJob = function (_a) {
    var _b, _c;
    var isOpen = _a.isOpen, handleClose = _a.handleClose, record = _a.record;
    var role = JSON.parse(userInformation).roles[0];
    var socialMedias = JSON.parse(userInformation).socialMedias;
    var socmedIds = socialMedias === null || socialMedias === void 0 ? void 0 : socialMedias.map(function (socmed) { return socmed.pubId; });
    var teamPubId = JSON.parse(userInformation).teams;
    var navigate = useNavigate();
    var processJob = useJob().processJob;
    var _d = useState(), detailAddress = _d[0], setDetailAddress = _d[1];
    var _e = useState(false), loading = _e[0], setLoading = _e[1];
    var _f = useState([]), selectedAddress = _f[0], setSelectedAddress = _f[1];
    var _g = useState([]), selectedBank = _g[0], setSelectedBank = _g[1];
    var _h = useState([]), selectedBankName = _h[0], setSelectedBankName = _h[1];
    var _j = useState([]), selectedCityAddress = _j[0], setSelectedCityAddress = _j[1];
    var _k = useState([]), selectedCityBank = _k[0], setSelectedCityBank = _k[1];
    var _l = useState(defaultOptionAddress), optionAddress = _l[0], setOptionAddress = _l[1];
    var _m = useState(defaultOptionBank), optionBank = _m[0], setOptionBank = _m[1];
    var _o = useState({
        page: 1,
        pageSize: 200,
        keyword: '',
        filterBy: "[[\"talent.pubId\", \"".concat(record.talent.pubId, "\"]]"),
        initialFilterBy: "[[\"recordStatus\", \"Active\"]]",
    }), filter = _o[0], setFilter = _o[1];
    var _p = useState({
        page: 1,
        pageSize: 100,
        keyword: '',
        filterBy: '[]',
        initialFilterBy: "[[\"recordStatus\", \"Active\"]]",
    }), filterJobType = _p[0], setFilterJobType = _p[1];
    var _q = useState({
        page: 1,
        pageSize: 10,
        keyword: '',
        filterBy: "[['team.pubId', '".concat(teamPubId[0].pubId, "']]"),
        initialFilterBy: "[]",
    }), filterSaldoTeam = _q[0], setFilterSaldoTeam = _q[1];
    var _r = useState(jobInitialValues), initialFormValues = _r[0], setInitialFormValues = _r[1];
    var _s = useAddresses(record === null || record === void 0 ? void 0 : record.talent.pubId, !!((_b = record === null || record === void 0 ? void 0 : record.talent) === null || _b === void 0 ? void 0 : _b.pubId), filter), addresses = _s.addresses, isLoadingAddress = _s.isLoading;
    var _t = useBankAccounts(record === null || record === void 0 ? void 0 : record.talent.pubId, !!((_c = record === null || record === void 0 ? void 0 : record.talent) === null || _c === void 0 ? void 0 : _c.pubId), filter), bankAccounts = _t.bankAccounts, isLoadingBankAccount = _t.isLoading;
    var _u = useState(), socialMediaId = _u[0], setSocialMediaId = _u[1];
    var _v = useJobTypes(filterJobType), jobTypes = _v.jobTypes, refetchJobType = _v.refetch;
    var cities = useCities().cities;
    var banks = useBanks(filter).banks;
    var saldoTeams = useSaldoTeams(filterSaldoTeam).saldoTeams;
    var bankList = (banks === null || banks === void 0 ? void 0 : banks.data) &&
        (banks === null || banks === void 0 ? void 0 : banks.data.length) > 0 &&
        (banks === null || banks === void 0 ? void 0 : banks.data.map(function (bank) { return ({
            label: bank.name,
            value: bank.pubId,
        }); }));
    var addressList = addresses &&
        addresses.length > 0 &&
        addresses.map(function (address) { return ({
            label: address.address,
            value: address.pubId,
        }); });
    var talentBankList = bankAccounts &&
        bankAccounts.length > 0 &&
        bankAccounts.map(function (bank) { return ({
            label: "".concat(bank.accountName, " - ").concat(bank.accountNumber, " - ").concat(bank.bank.name),
            value: bank.pubId,
        }); });
    var optionJobType = (jobTypes === null || jobTypes === void 0 ? void 0 : jobTypes.data) &&
        (jobTypes === null || jobTypes === void 0 ? void 0 : jobTypes.data.length) > 0 &&
        (jobTypes === null || jobTypes === void 0 ? void 0 : jobTypes.data.map(function (job) { return ({
            name: job.name,
            value: job.pubId,
        }); }));
    var optionCity = (cities === null || cities === void 0 ? void 0 : cities.data) &&
        (cities === null || cities === void 0 ? void 0 : cities.data.length) > 0 &&
        (cities === null || cities === void 0 ? void 0 : cities.data.map(function (city) { return ({
            label: city.name,
            value: city.pubId,
        }); }));
    var JobProcessFormik = useFormik({
        enableReinitialize: true,
        initialValues: initialFormValues,
        validationSchema: JobProcessFormSchema,
        onSubmit: function (values, _a) {
            var resetForm = _a.resetForm, setStatus = _a.setStatus, setSubmitting = _a.setSubmitting;
            return __awaiter(void 0, void 0, void 0, function () {
                var formValues, removeDotsFromKeys, addressDetails, addressRecipientName, addressRecipientNumber, addressCity, bankPubId, bankAccountName, bankAccountNumber, bankOfficeBranch, bankCity, talentAddressPubId, talentBankAccountPubId, totalTransferredFee, bank, address, details, totalFeeBundling, value, finalFormValue, bankAndAddressFormValue, finalDetails, finalTotalFeeBundling, formData, e_1, error;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, 3, 4]);
                            formValues = __assign({ id: record.pubId }, values);
                            removeDotsFromKeys = function (arr, keys) {
                                return arr.map(function (item) {
                                    var updatedItem = __assign({}, item);
                                    // Loop through the specified keys and remove dots
                                    keys.forEach(function (key) {
                                        if (updatedItem[key]) {
                                            updatedItem[key] = updatedItem[key].replace(/\./g, '');
                                        }
                                    });
                                    return updatedItem;
                                });
                            };
                            addressDetails = formValues.addressDetails, addressRecipientName = formValues.addressRecipientName, addressRecipientNumber = formValues.addressRecipientNumber, addressCity = formValues.addressCity, bankPubId = formValues.bankPubId, bankAccountName = formValues.bankAccountName, bankAccountNumber = formValues.bankAccountNumber, bankOfficeBranch = formValues.bankOfficeBranch, bankCity = formValues.bankCity, talentAddressPubId = formValues.talentAddressPubId, talentBankAccountPubId = formValues.talentBankAccountPubId, totalTransferredFee = formValues.totalTransferredFee, bank = formValues.bank, address = formValues.address, details = formValues.details, totalFeeBundling = formValues.totalFeeBundling, value = __rest(formValues, ["addressDetails", "addressRecipientName", "addressRecipientNumber", "addressCity", "bankPubId", "bankAccountName", "bankAccountNumber", "bankOfficeBranch", "bankCity", "talentAddressPubId", "talentBankAccountPubId", "totalTransferredFee", "bank", "address", "details", "totalFeeBundling"]);
                            finalFormValue = value;
                            bankAndAddressFormValue = {};
                            if (talentAddressPubId === 'add-new' && talentBankAccountPubId !== 'add-new') {
                                bankAndAddressFormValue = {
                                    address: address,
                                    talentBankAccountPubId: talentBankAccountPubId,
                                };
                            }
                            else if (talentAddressPubId !== 'add-new' && talentBankAccountPubId === 'add-new') {
                                bankAndAddressFormValue = {
                                    bank: bank,
                                    talentAddressPubId: talentAddressPubId,
                                };
                            }
                            else if (talentAddressPubId === 'add-new' && talentBankAccountPubId === 'add-new') {
                                bankAndAddressFormValue = {
                                    address: address,
                                    bank: bank,
                                };
                            }
                            else if (talentAddressPubId !== 'add-new' && talentBankAccountPubId !== 'add-new') {
                                bankAndAddressFormValue = {
                                    talentAddressPubId: talentAddressPubId,
                                    talentBankAccountPubId: talentBankAccountPubId,
                                };
                            }
                            finalDetails = removeDotsFromKeys(details, [
                                'fee',
                                'totalFollowers',
                                'totalPosts',
                            ]);
                            finalTotalFeeBundling = totalFeeBundling && totalFeeBundling.replace(/\./g, '');
                            formData = __assign(__assign(__assign({}, finalFormValue), bankAndAddressFormValue), { details: finalDetails, totalFeeBundling: finalTotalFeeBundling });
                            setLoading(true);
                            return [4 /*yield*/, processJob(formData)];
                        case 1:
                            _b.sent();
                            handleClose();
                            navigate("#".concat(JobTypeEnum[1]));
                            return [3 /*break*/, 4];
                        case 2:
                            e_1 = _b.sent();
                            error = e_1.response.data;
                            setStatus(error.message);
                            setSubmitting(false);
                            setLoading(false);
                            return [3 /*break*/, 4];
                        case 3:
                            resetForm();
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        },
    });
    var handleAdd = function () {
        var newDetails = {
            profilePubId: '',
            jobTypePubId: '',
            exclusiveStatus: '',
            fee: 0,
            totalPosts: 0,
            totalFollowers: 0,
            timeFrame: '',
            notes: '',
            owningType: '',
            boostingType: ''
        };
        setInitialFormValues(function (prevState) { return (__assign(__assign({}, prevState), { details: __spreadArray(__spreadArray([], prevState.details, true), [newDetails], false) })); });
    };
    var handleRemove = function (index) {
        var updatedDetails = __spreadArray([], initialFormValues.details, true);
        updatedDetails.splice(index, 1);
        setInitialFormValues(function (prevState) { return (__assign(__assign({}, prevState), { details: updatedDetails })); });
    };
    var onChangeAddress = function (e) {
        setSelectedAddress(e);
        JobProcessFormik.values.talentAddressPubId = e.value;
    };
    var onChangeBank = function (e) {
        setSelectedBank(e);
        JobProcessFormik.values.talentBankAccountPubId = e.value;
    };
    var onChangeBankName = function (e) {
        setSelectedBankName(e);
        JobProcessFormik.values.bank.bankPubId = e.value;
    };
    var onChangeCityAddress = function (e) {
        setSelectedCityAddress(e);
        JobProcessFormik.values.addressCity = e.value;
        JobProcessFormik.values.address.cityPubId = e.value;
    };
    var onChangeCityBank = function (e) {
        setSelectedCityBank(e);
        JobProcessFormik.values.bankCity = e.value;
        JobProcessFormik.values.bank.cityPubId = e.value;
    };
    useEffect(function () {
        var profileId = socialMediaId && (record === null || record === void 0 ? void 0 : record.talent.profiles.filter(function (obj) { return socialMediaId.includes(obj.pubId); }).map(function (profile) { return profile.socialMedia.pubId; }));
        profileId && setFilterJobType(__assign(__assign({}, filterJobType), { filterBy: "[[\"socialMedia.pubId\",'".concat(profileId, "']]") }));
        profileId && refetchJobType();
    }, [socialMediaId]);
    useEffect(function () {
        setInitialFormValues(JobProcessFormik.values);
    }, [JobProcessFormik.values]);
    useEffect(function () {
        if (addresses) {
            var address = addresses.filter(function (address) { return address.pubId === JobProcessFormik.values.talentAddressPubId; });
            setDetailAddress(address);
        }
    }, [JobProcessFormik.values.talentAddressPubId]);
    useEffect(function () {
        if (addressList) {
            var address = optionAddress.concat(addressList);
            setOptionAddress(address);
        }
    }, [addresses]);
    useEffect(function () {
        if (talentBankList) {
            var bank = optionBank.concat(talentBankList);
            setOptionBank(bank);
        }
    }, [bankAccounts]);
    return (_jsx(DrawerComponent, __assign({ open: isOpen, size: 'LG', handleClose: handleClose, title: 'Process a Job' }, { children: _jsx("form", __assign({ className: 'form w-100', onSubmit: JobProcessFormik.handleSubmit, noValidate: true, id: 'job-process-form' }, { children: record && (_jsxs("div", { children: [_jsxs("div", __assign({ className: 'mb-3' }, { children: [_jsx("div", { children: _jsx(Typography, __assign({ variant: 'body1' }, { children: "Nama Talent" })) }), _jsx("div", { children: _jsx(Typography, __assign({ variant: 'h6' }, { children: record.talent.name })) })] })), _jsxs("div", __assign({ className: 'mb-3' }, { children: [_jsx("div", { children: _jsx(Typography, __assign({ variant: 'body1' }, { children: "Contact Person" })) }), _jsx("div", { children: _jsxs(Typography, __assign({ variant: 'h6' }, { children: [record.talent.cpName, " - ", record.talent.cpPhoneNumber] })) })] })), _jsx(Divider, {}), _jsx("div", __assign({ className: 'my-5' }, { children: !isLoadingAddress && optionAddress && (_jsxs(Fragment, { children: [_jsx(MultiSelectFormik, { name: 'talentAddressPubId', label: 'Talent Address', formik: JobProcessFormik, isMulti: false, options: optionAddress, value: selectedAddress, onchange: onChangeAddress }), detailAddress &&
                                    detailAddress.length > 0 &&
                                    detailAddress.map(function (address) {
                                        var _a;
                                        return (_jsxs("div", __assign({ style: { padding: '1rem', background: '#f9f9f9', borderRadius: '10px' } }, { children: [_jsxs(Typography, __assign({ variant: 'h6' }, { children: [address.recipientName, " - ", address.recipientPhoneNumber] })), _jsxs(Typography, __assign({ variant: 'h6' }, { children: [address.address, ", ", address.city.name, ", ", (_a = address.city) === null || _a === void 0 ? void 0 : _a.province.name] }))] }), address));
                                    }), JobProcessFormik.values.talentAddressPubId === 'add-new' && (_jsxs(Fragment, { children: [_jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Nama Penerima', type: 'text', placeholder: 'Nama Penerima', name: 'address.recipientName', formik: JobProcessFormik, isRequired: true }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Nomor Penerima', type: 'text', placeholder: 'Nomor Penerima', name: 'address.recipientPhoneNumber', formik: JobProcessFormik, isRequired: true }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(TextAreaFormik, { label: 'Alamat', placeholder: 'Alamat', name: "address.address", formik: JobProcessFormik, isRequired: true }) })), _jsx("div", __assign({ className: 'my-5' }, { children: optionCity && (_jsx(MultiSelectFormik, { name: 'address.cityPubId', label: 'Kota/Kabupaten', formik: JobProcessFormik, isMulti: false, options: optionCity, value: selectedCityAddress, onchange: onChangeCityAddress, isRequired: true })) }))] }))] })) })), _jsx("div", __assign({ className: 'my-5' }, { children: !isLoadingBankAccount && optionBank && (_jsxs(Fragment, { children: [_jsx(MultiSelectFormik, { name: 'talentBankAccountPubId', label: 'Talent Bank Account', formik: JobProcessFormik, isMulti: false, options: optionBank, value: selectedBank, onchange: onChangeBank }), JobProcessFormik.values.talentBankAccountPubId === 'add-new' && (_jsxs(Fragment, { children: [_jsx("div", __assign({ className: 'my-5' }, { children: bankList && (_jsx(MultiSelectFormik, { name: 'bank.bankPubId', label: 'Bank', formik: JobProcessFormik, isMulti: false, options: bankList, value: selectedBankName, onchange: onChangeBankName, isChildField: true, isRequired: true })) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Nomor Rekening', type: 'text', placeholder: 'Nomor Rekening', name: 'bank.accountNumber', formik: JobProcessFormik, isRequired: true }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Nama Penerima', type: 'text', placeholder: 'Nama Penerima', name: 'bank.accountName', formik: JobProcessFormik, isRequired: true }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Kantor Cabang', type: 'text', placeholder: 'Kantor Cabang', name: 'bank.branchName', formik: JobProcessFormik, isRequired: true }) })), _jsx("div", __assign({ className: 'my-5' }, { children: optionCity && (_jsx(MultiSelectFormik, { name: 'bank.cityPubId', label: 'Kota/Kabupaten', formik: JobProcessFormik, isMulti: false, options: optionCity, value: selectedCityBank, onchange: onChangeCityBank, isRequired: true })) }))] }))] })) })), _jsx(Divider, {}), (initialFormValues === null || initialFormValues === void 0 ? void 0 : initialFormValues.details) &&
                        (initialFormValues === null || initialFormValues === void 0 ? void 0 : initialFormValues.details.length) > 0 &&
                        (initialFormValues === null || initialFormValues === void 0 ? void 0 : initialFormValues.details.map(function (detail, index) { return (_jsx(Fragment, { children: _jsx(JobDetailForm, { useForm: JobProcessFormik, index: index, value: detail, removeDetail: handleRemove, record: record }) }, index)); })), _jsx("button", __assign({ type: 'button', className: 'btn btn-sm btn-success mb-5', onClick: handleAdd }, { children: "Tambah Detail Job" })), _jsx(Divider, {}), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Total Fee Bundling', type: 'text', placeholder: 'Total Fee Bundling', name: 'totalFeeBundling', formik: JobProcessFormik, formatNumber: true, onfocus: handleFocus }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsxs(Typography, __assign({ variant: 'h6' }, { children: [_jsx("b", { children: "Sisa Saldo:" }), " Rp. ", saldoTeams === null || saldoTeams === void 0 ? void 0 : saldoTeams.data.total.toLocaleString()] })) })), _jsx(Divider, {}), _jsx("div", __assign({ className: 'my-5' }, { children: _jsxs("div", __assign({ style: { textAlign: 'right' } }, { children: [_jsx("button", __assign({ type: 'button', className: 'btn btn-secondary btn-active-light-primary', onClick: handleClose, disabled: JobProcessFormik.isSubmitting, style: { marginRight: '1rem' } }, { children: "Batal" })), _jsxs("button", __assign({ type: 'submit', id: 'kt_jobtype_submit', className: 'btn btn-primary ', disabled: JobProcessFormik.isSubmitting || !JobProcessFormik.isValid }, { children: [!loading && _jsx("span", __assign({ className: 'indicator-label' }, { children: "Simpan" })), loading && (_jsxs("span", __assign({ className: 'indicator-progress', style: { display: 'block' } }, { children: ["Mohon tunggu...", _jsx("span", { className: 'spinner-border spinner-border-sm align-middle ms-2' })] })))] }))] })) }))] })) })) })));
};
export default ProcessJob;
